import {
  DEFAULT_QUERY_CLIENT_OPTIONS,
  throwOnAuthError,
} from '@/config/queryClient'
import { UserProvider } from '@/shared/contexts/userContext'
import { withQueryClient } from '@/shared/hooks/withQueryClient'
import { ReactNode } from 'react'

type RouteProps = {
  children: ReactNode
}

const PrivateRouteWrapper = ({ children }: RouteProps) => {
  return (
    <UserProvider throwOnError bailOnLoading>
      {children}
    </UserProvider>
  )
}

export const PrivateRoute = withQueryClient(PrivateRouteWrapper, {
  ...DEFAULT_QUERY_CLIENT_OPTIONS,
  queries: {
    ...DEFAULT_QUERY_CLIENT_OPTIONS.queries,
    throwOnError: throwOnAuthError,
  },
  mutations: {
    ...DEFAULT_QUERY_CLIENT_OPTIONS.mutations,
    throwOnError: throwOnAuthError,
  },
})
